import { Flex, Text } from '@grammarly/design-system'
import { FormattedMessage } from 'react-intl'

import { SignUpProductRecButton } from '@components/item/cta-button/signup-product-recommendation'
import { ButtonColor } from '@components/ui-lib/button'
import { useTool } from '../tool-context'

import styles from '../tool.module.scss'

export const ToolFooterBanner = () => {
  const { footerBannerCopy } = useTool()

  return (
    <Flex
      gap={4}
      marginTop={6}
      bgColor="purple-100"
      borderRadius={2}
      padding={4}
      margin="0 auto"
      justify="center"
      align="center"
      className={styles.toolFooterBannerContainer}
    >
      <Text variant="text-large" as="span" color="base-inverse">
        {footerBannerCopy}
      </Text>
      <SignUpProductRecButton
        compact
        color={ButtonColor.WDK24WhiteBlackText}
        text={
          <Text variant="text-large" as="span" color="base-default">
            <strong>
              <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
            </strong>
            &nbsp;&nbsp;
            <FormattedMessage id="phrase.itsFree" description="Sign up prompt value prop" defaultMessage="It's free" />
          </Text>
        }
        toQueryParam="editor"
      />
    </Flex>
  )
}
